<template>
  <div class="page-product-table-box">
    <div class="page-header">
        <h2>{{$t('dsfx.t13')}}</h2>
    </div>

    <div class="searchwrap">
      <el-form :inline="true" class="table-form-inline search-left">
        <el-form-item :label="$t('jgjk.s13')">
          <el-select v-model="filterselector[1].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters1change">
            <el-option
              v-for="item in filterselector[1].options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('jgjk.s14')">
          <el-select v-model="filterselector[2].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters2change">
            <el-option
              v-for="item in filterselector[2].options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="pricetablesearchline">
        <el-input 
          style="width:250px" 
          v-model="viewState.searchNeedle" 
          :placeholder="$t('jgjk.s64')" 
          size="mini" 
          @keyup.enter.native="onTableListSaerch()"
        ></el-input>
        <el-button type="danger" @click="onTableListSaerch()" size="mini">{{ $t('dsfx.t26') }}</el-button>
        <el-button type="danger" plain @click="downloaddatadialog()" :loading="downloading" size="mini">{{ $t('jgjk.s74') }}</el-button>
      </div>

    </div>
    
    <div class="tablebox">
      <el-table
        :cell-style="getTableCellStyle"
        size="mini"
        @sort-change="sortthiscolumn"
        v-loading="tableloading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @cell-dblclick="editSinglePrcie"
      >
        <el-table-column label="SKUID" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-html="scope.row.skuidIcon"></span>
          </template>          
        </el-table-column>
        <el-table-column prop='series' :label="$t('jgjk.s13')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop='sku' label="SKU Code" show-overflow-tooltip></el-table-column>
        <el-table-column prop='name' :label="$t('jgjk.s15')" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='type' :label="$t('jgjk.s16')" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='model' :label="$t('jgjk.s14')" show-overflow-tooltip></el-table-column>
        <el-table-column width="100">
          <template slot="header">
            {{ $t('jgjk.s305') }}
            <el-tooltip class="item" effect="dark" :content="$t('jgjk.s233')" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.isedittype ===  false">{{scope.row.price}}</span>
            <el-input 
              v-inputfocus
              onkeyup="value=value.replace(/[^0-9.]/g,'')" 
              class="editpriceinput" 
              v-model="scope.row.price" 
              v-if="scope.row.isedittype === true" 
              @blur="savePrice(scope.row.skuid, scope.row.price, scope.row)"
              @keyup.enter.native="savePrice(scope.row.skuid, scope.row.price, scope.row)"
              size="mini">
            </el-input>
          </template>          
        </el-table-column>
        <el-table-column prop='updateAt' :label="$t('jgjk.s17')" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='Discount' :label="$t('report.s38')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='LinkCount' :label="$t('jgjk.s6')" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column :width="getLowPriceType == 1 ? 110 : 90">
          <template slot="header">
            {{ $t('jgjk.s51') }}
            <!-- <el-tooltip class="item" effect="dark" :content="getLowPriceType == 0 ? 
            '未开启自动过滤极端折扣商品，请至设定页进行操作' : 
            '点击%图标按钮，输入需要过滤的最低折扣百分比'" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip> -->
            <el-tooltip class="item" effect="dark" content="如需开启低价自动过滤功能，请至“折扣设定”页面进行操作。点击百分比符号可设置对应SKU的低价过滤比例。" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template  slot-scope="scope">
            <button class="viewactivebrand" type="button" 
            @click="viewUrl(
              subid, 
              scope.row.skuid, 
              scope.row.sku,
              scope.row.channelname, 
              scope.row.name, 
              scope.row.series,  
              scope.row.model,
              scope.row.type,
              scope.row.price
            )"></button>
            <el-input 
              v-if="getLowPriceType == 1" 
              class="editdiscountinput" 
              :disabled="scope.row.iseditdiscount" 
              v-model="scope.row.lowpriceDiscount"
              @blur="updateLowpriceDiscount(scope.row)"
              @keyup.enter.native="updateLowpriceDiscount(scope.row)">
              <el-button slot="append" @click="setdiscountinput(scope.row)">%</el-button>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes"
        :total="pagingtotal">
      </el-pagination>      
    </div>

    <el-dialog
      custom-class="editskulink-datafeedback tousu-dialogbox"
      :title="$t('jgjk.s74')"
      :visible.sync="showdownloaddatadialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true">
      <div class="editskulink-body">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedchannels" @change="handleCheckedChannelsChange">
          <el-checkbox v-for="channel in allchannels" :label="channel" :key="channel">
              {{ channel }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showdownloaddatadialog = false; checkedchannels = []">{{$t('dsfx.t32')}}</el-button>
        <el-button :disabled="checkedchannels.length == 0" size="mini" type="primary" :loading="downloading" @click="downloaddatachanle()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: {
    getLowPriceType: String
  },
  data(){
    return{
      downloading: false,
      pagesize: 25,
      subid: this.$route.params.Id,
      pid: '',

      notviptable: false,
      balance: '',

      feedbackcomplaindialog: false,
      userbalance: '',
      feedbackcomplainsuccess: false,

      feedbacksuccess: false,
      feedbackBtnDisable: true,//true:隐藏
      feedbackBtnId: 0,//反馈类型：判定错误/链接失效
      feedbackTextarea: '',//系统反馈内容
      feedbackSelectedIds: '',//反馈的数据ID
      feedbackOptionsval: null,
      feedbackOptions: [],
      feedbackdialogopen: false,//意见反馈对话框是否打开
      tableloading: true,
      viewState: {
          selectedTab: "tab_all",
          searchNeedle: '',
          model4Tab: {}
      },
      refresh: false,
      formInline: {
        user: '',
        region: ''
      },
      filterselector: [{
          fieldid: "ChannelName",
          source: "channels",
          options: [],
          default: ''
      },{
          fieldid: "Series",
          source: "series",
          options: [],
          default: ''
      },{
          fieldid: "Model",
          source: "model",
          options: [],
          default: ''
      },{
          fieldid: "Result",
          source: "result",
          options: [{
            name: '全部',
            value: ''
          },{
            name: this.$t('DashboardProduct.barlegendnamefalse'),
            value: 0,
          },{
            name: this.$t('DashboardProduct.barlegendnametrue'),
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Bucket",
          source: "bucket",
          options: [{
            name: '全部',
            value: ''
          },{
            name: '低',
            value: 3,
          },{
            name: '中',
            value: 2,
          },{
            name: '高',
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Authorize",
          source: "authorize",
          options: [{
            name: '全部',
            value: ''
          },{
            name: '是',
            value: 1,
          },{
            name: '否',
            value: 0,
          }],
          default: ''
      }],
      tableviewQuery: {
        start: this.$store.state.startDate+' 00:00:00',
        end: this.$store.state.endDate+' 23:59:59',
        page: this.$route.query.page ? this.$route.query.page/1 : 1,
        rpstatus: "",
        channel: "",//渠道：淘宝/天猫
        result: "", //判断结果：真/假
        bucket: "", //确信度：高中低
        search: "",
        brand: "",
        authorize: ""
      },
      currentPage1: this.$route.query.page ? this.$route.query.page/1 : 1,
      tabs: [
        {
          id: "tab_all",
          filter: '',                
          sum: 0,
          isActive: true
        },
        {
          id: "tab_pending",
          filter: 1,
          sum: 0,
        },
        {
          id: "tab_waiting",
          filter: 2,
          sum: 0,
        },
        {
          id: "tab_progress",
          filter: 5,
          sum: 0,
        },
        {
          id: "tab_success",
          filter: 4,
          sum: 0,
        },
        {
          id: "tab_failed",
          filter: 3,
          sum: 0,
        }
      ],
      tableorder: null,
      tableData: [],
      multipleSelection: [],
      pagingtotal: 0,
      DiscriminantResultText: '',
      channelIdAndNameMap: {},
      disableOptionsRefresh: false,
      showdownloaddatadialog: false,
      isIndeterminate: true,
      checkAll: false,
      checkedchannels: [],
      allchannels: [],
      lowpricediscount: JSON.parse(localStorage.getItem("lowpriceDiscount")) != null 
                        && JSON.parse(localStorage.getItem("lowpriceDiscount")) != undefined 
                        && JSON.parse(localStorage.getItem("lowpriceDiscount")) != '' 
                        ? JSON.parse(localStorage.getItem("lowpriceDiscount")).val : '0',
    }
  },

  mounted(){
    let that = this
    // that.requestUserBalance()
    that.requestTabAndDropdownData(that.$route.params.Id)
    that.tableviewModelChange(that.$route.params.Id)
    if(localStorage.getItem("viewurlpage")){
      localStorage.removeItem('viewurlpage')
    }
  },
  
  methods: {

    /**
     * 下载
     */
    
    handleCheckAllChange(val) {
      this.checkedchannels = val ? this.allchannels : [];
    },

    handleCheckedChannelsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.allchannels.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allchannels.length;
    },

    downloaddatadialog: function(){
      this.showdownloaddatadialog = true
    },

    downloaddatachanle: function(){
      let that = this
      let _cids = JSON.parse(JSON.stringify(that.checkedchannels))
      let _c = []
      for(let i=0; i<_cids.length; i++){
        _c[i] = that.setChannel(_cids[i]).cid
      }
      _c = _c.join(',')
      this.downloaddata(_c)
    },
    
    /**
     * 配置按钮事件
     */
    onClickSetting: function(){
      this.notviptable = true
    },

    //24小时只能投诉一次
    selectable(row) {
      //console.log('selectable', row)
      if(this.tableviewQuery.rpstatus === 1){
        return true
      }else{
        if(row.Feedback === 1){
          return false;
        }else{
          return true;
        }
      }
    },

    //投诉建议

    //实时获取用户点数
    requestUserBalance: function(){
      let that = this
      let url = that.API_URL + '/v3/users/quota';
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        //data: JSON.stringify(submitFeedbackData),
        success: function(rex) {
          // console.log('----requestUserBalance', rex)
          //that.myblancecost = rex.cost
          that.balance = rex.balance
        },
        error: function(response) {
          console.log('requestUserBalance', response)
        }
      })
    },

    onSubmitFeedbackComplain: function(){
      if(this.feedbackSelectedIds.length < 1) return
      console.log('onSubmitFeedbackComplain',this.balance);
      this.feedbackcomplaindialog = true
      this.userbalance = this.balance
      //this.userbalance = JSON.parse(localStorage.getItem("balance")).val
    },

    onSubmitFeedbackComplainCancel: function(){
      this.feedbackcomplaindialog=false
      this.toggleSelection()
    },

    onSubmitFeedback: function(){
      this.feedbackdialogopen = true
      if(this.feedbackSelectedIds.length < 1){
        this.feedbackBtnDisable = true
      }else{
        this.feedbackBtnDisable = false
      }
    },

    onTableListSaerch: function(){
      let searchKey = this.viewState.searchNeedle
      console.log('onTableListSaerch', searchKey)
      let that = this
      that.tableviewModelChange(that.$route.params.Id)
    },

    filters0change: function(val){
      this.filterselector[0].default = val === '全部' ? '' : val
      console.log('filters0change', val)
      this.disableOptionsRefresh = true
      this.reloadTableData()
    },
    filters1change: function(val){
      this.filterselector[1].default = val === '全部' ? '' : val
      this.disableOptionsRefresh = true
      this.$store.state.priceSeries = val === '全部' ? '' : val
      this.reloadTableData()
    },
    filters2change: function(val){
      this.filterselector[2].default = val === '全部' ? '' : val
      this.disableOptionsRefresh = true
      this.$store.state.priceModel =val === '全部' ? '' : val
      this.reloadTableData()
    },
    filters3change: function(val){
      this.filterselector[3].default = val === '全部' ? '' : val
      console.log(val)
      this.disableOptionsRefresh = true
      this.reloadTableData()
    },

    reloadTableData: function(){
      let that = this
      this.tableviewQuery.page = '1',
      this.currentPage1 = 1,
      this.channel = this.filterselector[0].default,
      this.result = this.filterselector[1].default,
      this.bucket = this.filterselector[2].default,
      that.requestTabAndDropdownData(that.$route.params.Id)
      that.tableviewModelChange(that.$route.params.Id)
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      let that = this
      that.currentPage1 = 1
      that.tableviewQuery.page = 1
      that.pagesize = val
      that.tableviewModelChange(that.$route.params.Id)
    },
    handleCurrentChange(val) {
      let that = this
      that.tableviewQuery.page = val
      // that.$router.replace({
      //   query:{
      //     page: val
      //   }
      // })
      that.tableviewModelChange(that.$route.params.Id)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    /**
     * 获取下拉菜单选项
     */
    requestTabAndDropdownData(subid) {
      let that = this;
      let url = that.API_URL + '/v3/price/monitor/filter';
      let data = {
        subid: subid,
        start: '',
        end: '',
        // start: that.$store.state.startDate+' 00:00:00',
        // end: that.$store.state.endDate+' 23:59:59',
        channel: that.filterselector[0].default,
        series: that.filterselector[1].default,
        model: that.filterselector[2].default,
        search: this.viewState.searchNeedle
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          // console.log('requestTabAndDropdownData', rex)

          let sumNumberOfAllTabs = rex.results[0].reduce((acc,val) => {
            return acc+val;
          },0);
          that.tabs[0].sum = sumNumberOfAllTabs
          // console.log('sumNumberOfAllTabs',sumNumberOfAllTabs);
          
          let newTabNumberDisplay = [sumNumberOfAllTabs,0,0,0,0,0]

          rex.results[0].forEach((val) => {
            if(val.RightsProtectionStatus == 0) {
              // 0 是真货，跳过
              return;
            }
            newTabNumberDisplay[val.RightsProtectionStatus] = val['CountNum'];
          })
          that.tabs.forEach((tab)=>{
            if(tab.filter === '') {
              tab.sum = newTabNumberDisplay[0];
              return;
            }
            tab.sum = newTabNumberDisplay[tab.filter]
          })

          //chanel
          let selectdefaultval = {
            name : that.$t('tabletabs.all'),
            value : ''
          }
          that.filterselector[0].options = rex.results[1].map(function(val){
            return {
              name: val.Channel,
              value: val.Channel
            }
          })
          that.filterselector[0].options.unshift(selectdefaultval)

          that.allchannels = rex.results[1].map(function(val){
            return that.setChannel(val.Channel).name
          })
          
          that.checkedchannels = rex.results[1].map(function(val){
            return that.setChannel(val.Channel).name
          })

          //series
          that.filterselector[1].options = rex.results[2].map(function(val){
            return {
              name: val.Series,
              value: val.Series
            }
          })
          that.filterselector[1].options.unshift(selectdefaultval)

          //Model
          /**
           * 去除型号中的空值
           */
          let modelarr = rex.results[3]
          for(let q = 0; q < modelarr.length; q++) {
            if(modelarr[q].Model == '') {
              modelarr.splice(q,1)
              q = q - 1
            }
          }
          that.filterselector[2].options = modelarr.map(function(val){
            return {
              name: val.Model,
              value: val.Model
            }
          })
          that.filterselector[2].options.unshift(selectdefaultval)

        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 获取详情列表
     */
    tableviewModelChange: function(subid){
      let that = this
      let url = that.API_URL + '/v3/price/monitor/paging'
      let gets = {
        subid: subid,
        page: that.tableviewQuery.page,
        start: '',
        end: '',
        channel: that.filterselector[0].default,
        series: that.filterselector[1].default.replace(/'/, "\\'"),
        model: that.filterselector[2].default.replace(/'/, "\\'"),
        search: that.viewState.searchNeedle,
        order: that.tableorder,
        size: that.pagesize
      }
      that.activeTableLoader()
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
				crossDomain: true,
				data: gets,
        success: function(data){
          let rex = data.results[1]
          // if(data.results[0][0].Count == 0){
          //   that.$router.push({ name: 'DataPending', params: {Id: subid} })
          // }
          rex.forEach(item => {
            item.updateAt = item.updateAt ? that.$moment(item.updateAt).format('MM-DD HH:mm') : ''
            item.trend = ''
            item.Discount = (item.Discount * 100).toFixed(2) + "%"
            item.skuidIcon = item.HasNew/1 === 1 ? item.skuid + ' <i class="icon-newdata-txt">New</i>' : item.skuid
            item.price = item.price * 1,
            item.isedittype = false
            item.iseditdiscount = true
          })
          that.tableData = rex
          that.shutTableLoader()
          that.pagingtotal = data.results[0][0].Count
        },
        error: function(err){
          console.log(err)
        }
      })
    },

    /**
     * 7日低价趋势
     */
    getLast7DaysTrend: function(sku, channel){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/daily'
      $.ajax({
        url:  url,
        type: "GET",
        data: {sku: sku, channel: channel},
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getLast7DaysTrend', rex)
        },
        error: function(response) {
          console.log('getLast7DaysTrend', response)
        }
      })
    },

    /**
     * 查看URL
     */
    viewUrl: function(subid, skuid, sku, channel, name, series, model, type, price){
      let ViewUrlPagedata = {
        subid: subid/1,
        skuid: skuid/1,
        sku: sku,
        channel: channel,
        name: name,
        series: series,
        model: model,
        type: type,
        price: price
      }
      this.setLocalStorage( "viewurl", ViewUrlPagedata )
      this.$router.push({name: 'ViewUrl', params: {Id: subid, SkuId: skuid}})    
    },

    // loader for table 
    activeTableLoader: function() {
      this.tableloading = true
    },

    shutTableLoader: function() {
      this.tableloading = false
    },    

    sortthiscolumn: function(column){
      if(column.prop == "type" && column.order == "ascending"){
        this.tableorder = 10
        this.reloadTableData()
      }else if(column.prop == "type" && column.order == "descending"){
        this.tableorder = 11
        this.reloadTableData()
      }else if(column.prop == "type" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "model" && column.order == "ascending"){
        this.tableorder = 20
        this.reloadTableData()
      }else if(column.prop == "model" && column.order == "descending"){
        this.tableorder = 21
        this.reloadTableData()
      }else if(column.prop == "model" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "Discount" && column.order == "ascending"){
        this.tableorder = 40
        this.reloadTableData()
      }else if(column.prop == "Discount" && column.order == "descending"){
        this.tableorder = 41
        this.reloadTableData()
      }else if(column.prop == "Discount" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "LinkCount" && column.order == "ascending"){
        this.tableorder = 50
        this.reloadTableData()
      }else if(column.prop == "LinkCount" && column.order == "descending"){
        this.tableorder = 51
        this.reloadTableData()
      }else if(column.prop == "LinkCount" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else{
        return
      }
    },

    /**
     * 下载数据
     */
    downloaddata: function(_cid){
      let that = this
      that.downloading = true
      let startobj = new Date()
      let nowtime = new Date()
      startobj.setTime(startobj.getTime() - 3600 * 1000 * 24 * 29)
      let start30day = new Date(that.$moment(startobj,'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYY-MM-DD'))
      //let currentstartday = new Date(that.$store.state.startDate)
      let currentstartday = new Date()
      let checkstart = start30day <= currentstartday ? true : false
      let objname = JSON.parse(localStorage.getItem("price")).val
      let filenametime = that.$moment(nowtime,'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYYMMDDHHmm')
      let newname = ''
      for(let k=0; k<objname.length; k++){
        if(objname[k].subid/1 === that.$route.params.Id/1)
        newname = objname[k].name
      }
      checkstart = true
      if(checkstart){      
        let url = that.API_URL
                  +'/v3/price/statistics/item?subid=' + that.subid
                  +'&channelId='
                  +_cid
                  +'&start='
                  +'&end='
        let filename = newname ? newname : 'Download'
        let xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
        xhr.responseType = "blob"
        xhr.onload = function () {
          if (this.status === 200) {
            var blob = this.response;
            var reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onload = function (e) {
              var a = document.createElement('a')
              a.download = filename + '_Price_SKU_' + filenametime+'.xlsx'
              a.href = e.target.result
              $("body").append(a)
              a.click()
              $(a).remove()
              that.downloading = false
              that.showdownloaddatadialog = false
              that.checkedchannels = []
            }
          }
        }
        xhr.send()
      }else{
        that.$message.error('只能下载最近30天数据')
      }
    },

    /**
     * 修改行内价格
     */
    editSinglePrcie: function(row, column){
      if(column.id == 'el-table_1_column_7'){
        row.isedittype = true
      }
    },    

    /**
     * 保存行内价格修改
     */
     savePrice: function(id, price, row){
      let that = this
      if(price===''){
        return 
      }
      row.isedittype = false
      let url = that.API_URL + '/v3/price/monitor/updatesku'
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {skuid: id, price: price},
        success: function(data) {
          console.log('savePrice', data)
          row.isedittype = false
        },
        error: function(response) {
          console.log('savePrice', response)
        }
      })
    },

    setdiscountinput: function(row){
      row.iseditdiscount = false
    },

    updateLowpriceDiscount: function(row){
      let that = this
      if(row.lowpriceDiscount > 99 && row.lowpriceDiscount < 1){
        return 
      }
      let url = that.API_URL + '/v3/price/monitor/updatediscount'
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {skuid: row.skuid, discount: row.lowpriceDiscount},
        success: function(data) {
          console.log('updateLowpriceDiscount', data)
          row.iseditdiscount = true
        },
        error: function(response) {
          console.log('savePrice', response)
        }
      })
    },

  }
}
</script>